<template>
  <div>
    <div class="content content_middle">
      <p class="content_middle_title page_color_1C2438">营业执照</p>
      <ul>
        <li id="se_bg_pufa">
          <input
            id="uploaderInputSecond"
            class="input uploaderInputSecond"
            type="file"
            accept="image/*"
            @change="uploadImage"
          />
          <img
            :src="businessLicenseImg"
            v-if="businessLicenseImg"
          />
          <i class="add_ico">+</i>
        </li>
        <p class="instruction">
          上传要求：<br />
          1、上传完整、清晰、有效的营业执照原件<br />
          2、单张图片最大不超过5M
        </p>
      </ul>
      <Button
        :loading="Isloading"
        loadingText="提交中..."
        :text="draw"
        :type="danger"
        :disabled="Isloading"
        class="nextStep"
        :click="submit"
      />
    </div>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>
<script>
import { Toast } from 'vant';
import Button from '@/components/Button.vue';
import ServerBank from '@/components/ServerBank.vue';
import { checkStatus } from '@/views/pages/commonPage/mixin';

export default {
  name: 'BusinessLicenseUpload',
  data() {
    return {
      businessLicenseImg: '',
      idFrontPic: '',
      danger: 'danger',
      draw: '下一步',
      Isloading: false,
      showContent: '',
    };
  },
  components: {
    Button,
    ServerBank
  },
  mixins: [checkStatus],
  mounted() {
    // TODO 反显证件照接口名及返回值确认 (idFrontPic)
    // const { orderId } = this.$router.currentRoute.query;
    // this.$api.CommonForms.getUploadIdentityUrl({ orderId }).then((res) => {
    //   const { idFrontPic } = res.data;
    //   this.businessLicenseImg = idFrontPic;
    // });
  },
  methods: {
    uploadImage(e) {
      const self = this;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      const file = files[0]; // File对象
      this.idFrontPic = file;
      if (this.validate_img(files[0])) {
        // eslint-disable-next-line prefer-destructuring
        self.uploadFile = files[0];
        const reader = new FileReader(); // FileReader对象
        reader.readAsDataURL(files[0]); // 该方法会读取指定的 Blob 或 File 对象。读取操作完成的时候，readyState 会变成已完成（DONE），并触发 loadend 事件，同时 result 属性将包含一个data:URL格式的字符串（base64编码）以表示所读取文件的内容。
        reader.onload = (item) => {
          self.businessLicenseImg = item.target.result; // 图片内容的base64编码
        };
      }
    },

    validate_img(file) {
      if (!/.(jpg|png|jpeg)$/i.test(file.name)) {
        Toast('请上传正确格式的营业执照');
        return false;
      }
      if (file.size.toFixed(5) >= 5 * 1024 * 1024) {
        Toast('请上传小于5M的图片');
        return false;
      }
      return true;
    },

    // eslint-disable-next-line consistent-return
    submit() {
      if (!this.businessLicenseImg) {
        return Toast('请上传营业执照图片');
      }

      const form = new FormData();
      form.append('orderId', this.$router.currentRoute.query.orderId);
      form.append('busiImage', this.idFrontPic);
      this.Isloading = true;
      this.$api.CommonForms.uploadBusiImageSNServer(form).then((res) => {
        if (res.success) {
          this.Isloading = false;
          this.$store.dispatch('otherPages/jumpCurrPageServer');
        } else {
          this.Isloading = false;
          Toast(res.returnMessage || '上传失败');
        }
      });
    },
  },
};
</script>
<style scoped>
/* 营业执照上传 */
body {
  background-color: #f8f8f9;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.content_middle {
  box-sizing: border-box;
  padding: 0 15px 15px 15px;
  background: #fff;
}

.content_middle_title {
  margin: 0;
  padding: 13px 0;
  font-size: 17px;
  text-align: left;
}

.content_middle ul {
  text-align: center;
  background: #fff;
}

.content_middle ul li {
  background: #999999;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  width: 227px;
  height: 149px;
  margin: 0 auto;
  overflow: hidden;
}

.content_middle ul li img {
  position: absolute;
  top: 0;
  left: 0;
  width: 227px;
  height: 149px;
}

.content_bottom {
  margin-top: 0.08rem;
  padding: 0 0.15rem;
}

.add_ico {
  font-family: -webkit-pictograph !important;
  font-style: initial !important;
  font-size: 4rem;
  font-weight: bold;
  color: #fff;
  margin-top: -0.8rem;
}

.btnBox {
  box-sizing: border-box;
  width: 100%;
  margin-top: 0.2rem;
  margin-bottom: 0.35rem;
  padding: 0 15px;
}

.btn {
  display: block;
  width: 100%;
  height: 44px;
  padding: 0;
  color: #fff;
  font-size: 17px;
  line-height: 44px;
  text-align: center;
  background-image: linear-gradient(-180deg, #f5514a 2%, #f5683c 99%);
  border-radius: 4px;
}

/* 文字颜色 */
.page_color_F65249 {
  color: #ff6538;
}

.page_color_A1A9B6 {
  color: #a1a9b6;
}

.page_color_A5ADB9 {
  color: #a5adb9;
}

.page_color_1C2438 {
  color: #1c2438;
}

/* input */
.input {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.instruction {
  width: 227px;
  margin: 0 auto;
  padding: 16px;
  font-size: 12px;
  color: #838d9b;
  text-align: left;
}
</style>
